/**
 * Shared helpers for grouping gallery photos under one event.
 */

export const normalizeEventKey = (value) => {
  if (!value || typeof value !== 'string') return '';
  return value
    .trim()
    .split(' — ')[0]
    .trim()
    .replace(/\s*\(\d+\)\s*$/, '')
    .trim();
};

export const getGalleryEventKey = (item) => {
  const fromEventTitle = normalizeEventKey(item?.eventTitle);
  if (fromEventTitle) return fromEventTitle;

  const fromTitle = normalizeEventKey(item?.title);
  if (fromTitle) return fromTitle;

  return item?.id || '';
};

export const getGalleryEventSiblings = (allItems, item) => {
  const key = getGalleryEventKey(item);
  return allItems.filter((entry) => getGalleryEventKey(entry) === key);
};
